import { LinearProgress } from '@mui/material';

type DataGridLoadingProps = {
  loading: boolean;
};
export function DataGridProgress({ loading }: DataGridLoadingProps) {
  return loading ? (
    <LinearProgress
      sx={(theme) => ({
        position: 'absolute',
        marginLeft: theme.spacing(2),
        width: `calc(100% - ${theme.spacing(4)})`,
        height: '1px',
        zIndex: 1,
      })}
    />
  ) : null;
}
